const styles = `
.pc {
    min-height: 100vh;
    background: #eef1f8;
    color: #14161a;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    padding-bottom: 40px;
}
.pc-topbar {
    background: #ffffff;
    border-bottom: 1px solid #e2e6ef;
    padding: 18px 28px;
}
.pc-topbar-inner {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}
.pc-toolbar {
    max-width: 1400px;
    margin: 0 auto;
}
.pc-back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 10px;
    padding: 9px 16px;
    font-size: 13.5px;
    font-weight: 600;
    color: #14161a;
    text-decoration: none;
    white-space: nowrap;
    transition: background .15s;
}
.pc-back-link:hover {
    background: #f4f6fa;
    color: #14161a;
}
.pc-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0;
    letter-spacing: -0.01em;
}
.pc-subtitle {
    color: #8992a6;
    font-size: 14px;
    margin-top: 2px;
}
.pc-header {
    background: #eef1f8;
    padding: 20px 28px 0;
}
.pc-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 16px 0 20px;
}
.pc-search {
    flex: 1 1 260px;
    min-width: 220px;
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 14px;
    outline: none;
    transition: border-color .15s;
}
.pc-search:focus {
    border-color: #3457d5;
}
.pc-search-status {
    font-size: 13px;
    color: #8992a6;
}
.pc-segmented {
    display: inline-flex;
    background: #e7eaf2;
    border-radius: 10px;
    padding: 3px;
}
    .pc-tabs {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 28px 18px;
    display: flex;
    align-items: center;
}

.pc-tab {
    border: none;
    background: transparent;
    color: #697386;
    padding: 9px 16px;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition:
        color .15s,
        border-color .15s,
        background .15s;
}

.pc-tab:hover {
    color: #14161a;
}

.pc-tab.active {
    color: #3457d5;
    border-bottom-color: #3457d5;
}
.pc-segmented button {
    border: none;
    background: transparent;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    color: #5b6472;
    border-radius: 8px;
    cursor: pointer;
    transition: all .15s;
}
.pc-segmented button.active {
    background: #ffffff;
    color: #14161a;
    box-shadow: 0 1px 2px rgba(16,24,40,0.08);
}
.pc-region-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
    color: #3457d5;
}
.pc-region-select {
    border: 1px solid #e2e6ef;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 13px;
    background: #fff;
    color: #14161a;
}
.pc-region-unknown {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #fff7e6;
    border: 1px solid #f3d9a4;
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 13px;
    color: #9a6a00;
    font-weight: 600;
}
.pc-body {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 28px 40px;
}
.pc-list {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.pc-empty {
    color: #8992a6;
    padding: 40px 0;
    text-align: center;
}
.pc-loading {
    display: flex;
    justify-content: center;
    padding: 60px 0;
}
.pc-spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid #dbe1ef;
    border-top-color: #3457d5;
    animation: pc-spin .8s linear infinite;
}
@keyframes pc-spin { to { transform: rotate(360deg); } }
.pc-item {
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16,24,40,0.04);
    overflow: hidden;
}
.pc-item-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    cursor: pointer;
    user-select: none;
}
.pc-item-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #e7edfd;
    color: #3457d5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}
.pc-item-main {
    flex: 1;
    min-width: 0;
}
.pc-item-name {
    font-weight: 700;
    font-size: 15px;
    color: #14161a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.pc-item-meta {
    color: #8992a6;
    font-size: 13px;
    margin-top: 2px;
}
.pc-item-price {
    text-align: right;
    flex-shrink: 0;
}
.pc-price-label {
    color: #8992a6;
    font-size: 12px;
    margin-right: 4px;
}
.pc-price-value {
    font-weight: 800;
    font-size: 16px;
    color: #14161a;
}
.pc-chevron {
    color: #8992a6;
    font-size: 11px;
    width: 16px;
    text-align: center;
    flex-shrink: 0;
}
.pc-suppliers {
    border-top: 1px solid #eef0f4;
}
.pc-supplier-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 18px;
    border-top: 1px solid #f2f4f8;
}
.pc-supplier-row:first-child {
    border-top: none;
}
.pc-supplier-info {
    flex: 1;
    min-width: 0;
}
.pc-supplier-source {
    font-weight: 600;
    font-size: 13.5px;
    color: #14161a;
}
.pc-supplier-manufacturer {
    color: #8992a6;
    font-size: 12.5px;
}
.pc-supplier-prices {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
}
.pc-price-chip {
    background: #eef0f4;
    color: #4b5563;
    border-radius: 8px;
    padding: 4px 9px;
    font-size: 12.5px;
    font-weight: 600;
}
.pc-price-chip.primary {
    background: #e7edfd;
    color: #3457d5;
}
.pc-supplier-date {
    color: #a5abb8;
    font-size: 12px;
    width: 76px;
    flex-shrink: 0;
}
.pc-qty-input {
    width: 60px;
    border: 1px solid #e2e6ef;
    border-radius: 8px;
    padding: 6px 8px;
    font-size: 13px;
    text-align: center;
}
.pc-add-btn {
    background: #14161a;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    flex-shrink: 0;
}
.pc-add-btn:hover {
    background: #2f333d;
}
.pc-cart-panel {
    flex: 0 0 380px;
    position: sticky;
    top: 20px;
    max-height: calc(100vh - 40px);
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16,24,40,0.04);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.pc-cart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e2e6ef;
    flex-shrink: 0;
}
.pc-cart-header h5 {
    margin: 0;
    font-weight: 800;
    font-size: 16px;
}
.pc-cart-count {
    background: #e7edfd;
    color: #3457d5;
    border-radius: 999px;
    padding: 2px 9px;
    font-size: 12.5px;
    font-weight: 700;
}
.pc-cart-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    min-height: 0;
}
.pc-cart-empty {
    color: #8992a6;
    text-align: center;
    padding: 30px 0;
}
.pc-cart-item {
    border-bottom: 1px solid #f2f4f8;
    padding: 12px 0;
}
.pc-cart-item-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}
.pc-cart-item-name {
    font-weight: 700;
    font-size: 14px;
}
.pc-cart-remove {
    border: none;
    background: #f2f4f8;
    color: #8992a6;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 13px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background .15s, color .15s;
}
.pc-cart-remove:hover {
    background: #fbe7e6;
    color: #d1453b;
}
.pc-cart-item-meta {
    color: #8992a6;
    font-size: 12.5px;
    margin-top: 2px;
}
.pc-cart-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}
.pc-cart-total {
    display: flex;
    justify-content: space-between;
    font-weight: 800;
    font-size: 15px;
    padding-top: 14px;
    margin-top: 6px;
    border-top: 1px solid #e2e6ef;
}
.pc-cart-footer {
    padding: 16px 20px;
    border-top: 1px solid #e2e6ef;
    flex-shrink: 0;
}
.pc-submit-btn {
    width: 100%;
    background: #3457d5;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
}
.pc-submit-btn:disabled {
    background: #c3cbe0;
    cursor: not-allowed;
}
.pc-cart-hint {
    color: #8992a6;
    font-size: 12.5px;
    margin-top: 8px;
    text-align: center;
}
/* Секции каталога/производств: заголовок кликабелен, содержимое сворачивается */
.pc-group-section {
    background: #ffffff;
    border: 1px solid #e2e6ef;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16,24,40,0.04);
    overflow: hidden;
    margin-bottom: 10px;
}
.pc-group-row {
    background: #f7f9fc;
}
.pc-group-row:hover {
    background: #eef2fb;
}
.pc-group-title {
    font-weight: 800;
    font-size: 15px;
    color: #14161a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.pc-group-items {
    border-top: 1px solid #eef0f4;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fbfcfe;
}
/* Вложенный уровень дерева категорий: чуть светлее и с отступом */
.pc-group-level-1 {
    border-color: #e8ecf5;
    box-shadow: none;
}
.pc-group-level-1 > .pc-group-row {
    background: #fbfcfe;
}
.pc-group-level-1 > .pc-group-row:hover {
    background: #f2f5fc;
}
.pc-group-level-1 .pc-group-title {
    font-weight: 700;
    font-size: 14px;
}
@media (max-width: 900px) {
    .pc-body { flex-direction: column; }
    .pc-cart-panel { position: static; flex: 1 1 auto; width: 100%; max-height: none; }
}
@media (max-width: 640px) {
    .pc-topbar, .pc-header, .pc-body { padding-left: 14px; padding-right: 14px; }
    .pc-supplier-row { flex-wrap: wrap; }
    .pc-supplier-date { display: none; }
}
`;

export default styles;
